<template>
  <div>
    <div class="video sxt-video">
      <!-- 主持人 -->
      <!-- <div id="f_ocx2" :class="activeVideo == 2 ? 'active' : ''">
        <iframe
          name="myiframe"
          id="ocx2"
          :src="cdbm"
          frameborder="0"
          align="middle"
          width="100%"
          height="100%"
          scrolling="no"
        ></iframe>
      </div> -->
      <!--  -->
      <div id="f_ocx2" :class="activeVideo == 2 ? 'active' : ''">
        <sxt class="video" :bdId="bdId" @send="send" ref="sharePlayer"></sxt>
      </div>
      <div id="f_ocx" :class="activeVideo == 1 ? 'active' : ''">
        <video
          id="video"
          controls
          muted
          class="video-js vjs-default-skin"
          autoplay
          preload="auto"
          width="458px"
          height="270px"
        >
          <source
            src="https://cmgw-vpc.lechange.com:8890/LCO/1M04FFFPAMT9203/8/1/20200713T095422/dev_1M04FFFPAMT9203_20200713T095422.m3u8?proto=https"
          />
        </video>
      </div>
    </div>
    <div class="videoBtns">
      <button
        v-for="(item, index) in btns"
        :key="index"
        :class="activeBtn == item.id ? 'active' : ''"
        type="button"
        @click="changeVideo(item.id)"
      >
        {{ item.text }}
      </button>
    </div>
  </div>
</template>
<script>
import sxt from "./sxt.vue";
import videojs from "video.js";
const playSrc = {
  1: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/1/1/20220425T111817/b84a46f754bf0d3e37b5cb026b3de29d.m3u8?proto=https",
  4: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/3/1/20210705T115920/56f99293f74b65f745b2b05ba7c0873f.m3u8?proto=https",
  8: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/7/0/20210705T154444/dd5dbb7c9dc6ab4de34309cca76d0ccd.m3u8?proto=https",
  10: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/9/1/20210705T154552/b4e5ff9984929eddf310e1f5a285d74e.m3u8?proto=https",
  11: "https://cmgw-vpc.lechange.com:8890/LCO/1M04FFFPAMT9203/11/0/20201120T060911/1f6a2015679386072e12b53142decbf3.m3u8?proto=https",
  12: "https://cmgw-vpc.lechange.com:8890/LCO/1M04FFFPAMT9203/8/1/20200713T095422/dev_1M04FFFPAMT9203_20200713T095422.m3u8?proto=https",
  16: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/16/1/20220425T111710/17bb918afc3a6a9694697838f72d30f6.m3u8?proto=https",
  17: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/17/1/20220425T111604/ba3d1d63b7372b333065e3ddb404bca7.m3u8?proto=https",
  998: "https://cmgw-vpc.lechange.com:8890/LCO/7L0D23CPAZA541F/0/0/20230129T013746/bb203e78ec79066e2e6af92f52f3106c.m3u8?proto=https", //圣奥归属机构
  997: "https://cmgw-vpc.lechange.com:8890/LCO/7L0D23CPAZA541F/1/0/20230129T014354/8e55a6f7dd2955e94af306b5279c1853.m3u8?proto=https", //圣奥归属机构
  tzzbs01:
    "https://open.ys7.com/v3/openlive/G71682661_1_2.m3u8?expire=1731927120&id=648234383618088960&t=dba4591c5883b80b848cf7343fa3b9ed596a08e51a6786030f2c5144a73d30e8&ev=100",
  tzzbs02:
    "https://open.ys7.com/v3/openlive/G71682661_7_2.m3u8?expire=1731927148&id=648234500428075008&t=443e76a5d61b48d3da07bb04861121736de4165c72494990eeb2ca9641a782ed&ev=100",
  tzzbs03:
    "https://open.ys7.com/v3/openlive/G71682661_8_1.m3u8?expire=1732328696&id=649918714552004608&t=246367fbbd14d83e5c2bd8cc68f72fc7fc0142f5b5c118d1a53fc7eab006477e&ev=100",
  tzzbs04:
    "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/7/1/20210705T154444/dd5dbb7c9dc6ab4de34309cca76d0ccd.m3u8?proto=https",
  tzzbs05:
    "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/11/1/20220425T111405/d8931179fc0282ee69608712de452118.m3u8?proto=https",
  tzzbs06:
    "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/15/1/20220425T111811/420fca6f9641359b60999e87316e0467.m3u8?proto=https",
  tzzbs07:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03849PAZE44D2/4/1/20230625T092935/78881e70f1243297b18e6242533216f0.m3u8?proto=https",
  tzzbs08:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03849PAZE44D2/1/0/20230625T072705/753cf02bf4d79bd674dd6ae2641aa5d6.m3u8?proto=https",
  tzzbs09:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03849PAZE44D2/18/1/20230625T093025/7a6dbb7edb29290dea00178de0b068ff.m3u8?proto=https",
  tzzbs10:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03849PAZE44D2/3/1/20230625T073458/6d284726faa037dd5c3a2edffce8b8a1.m3u8?proto=https",
  tzzbs11:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03849PAZE44D2/6/1/20230625T093133/dae9cf255b34c15a30cdd0a8f6a6fcd1.m3u8?proto=https",
  tzzbs12:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03849PAZE44D2/8/1/20230625T093150/7e794b05abf7dfe460a2bac6cd36fec5.m3u8?proto=https",
  tzzbs13:
    "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/0/1/20210705T115907/c95f9be1fbec2c03f54d47e865bc8ca4.m3u8?proto=https",
  tzzbs14:
    "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/7/1/20210705T154444/dd5dbb7c9dc6ab4de34309cca76d0ccd.m3u8?proto=https",
  tzzbs15:
    "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/10/1/20210705T120125/ec423ba2243de739ce5e8a833d65d583.m3u8?proto=https",
  tzzbs16:
    "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/5/1/20230116T033838/5569d0c455ab0feb919e7c40696d7556.m3u8?proto=https",
  tzzbs17:
    "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/11/1/20220425T111405/d8931179fc0282ee69608712de452118.m3u8?proto=https",
  tzzbs18:
    "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/15/1/20220425T111811/420fca6f9641359b60999e87316e0467.m3u8?proto=https",
  tzzbs19:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/12/1/20240117T005050/f8593ace306be5fdffac184b691cd712.m3u8?proto=https",
  tzzbs20:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/17/1/20240117T004920/d5fda0ca93e7c94547b3a3bc0c080c0f.m3u8?proto=https",
  tzzbs21:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/16/1/20240117T004932/07f9af73ab0649a0e1934207702a7a19.m3u8?proto=https",
  tzzbs23:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/7/1/20240117T011036/f7f640400fda784dd53c1e2cbbe3aa00.m3u8?proto=https",
  tzzbs24:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/2/1/20240117T011249/69cbf5e46048d6e362c4cd792bdf1a60.m3u8?proto=https",
  tzzbs25:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/14/1/20240117T005030/0fd1507ec86d5b0fca3d522e14d2ab66.m3u8?proto=https",
  tzzbs27:
    "https://open.ys7.com/v3/openlive/AZ1734932_1_2.m3u8?expire=1736995380&id=669492204052660224&t=906c94f8bebf5701fb3532a80b5993c424b3428edb0e3a62ae5e870842506b4c&ev=100",
  tzzbs28:
    "https://open.ys7.com/v3/openlive/AZ1734932_2_2.m3u8?expire=1736995413&id=669492346348617728&t=bc8b6bf9d022dd6e7d05bd3f68435bdd00b4b64e0c586788b65724a049a2cda4&ev=100",
  tzzbs29:
    "https://open.ys7.com/v3/openlive/AZ1734932_3_2.m3u8?expire=1736995426&id=669492400695029760&t=8f5273c29fdef6d2ef0ae024fe053f23e74ea8157241e158afce7a064d6fe906&ev=100",
  tzzbs30:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03849PAZE44D2/2/1/20230625T093054/559505880d395a7a631a4bf38ec6ae22.m3u8?proto=https",
  wxhkbs01:
    "https://open.ys7.com/v3/openlive/AZ1734992_1_1.m3u8?expire=1740729330&id=685153527722409984&t=83e48f8ad55e47d26265734f998cb5f53f6d17fc392a51d55931b29069bd1ee5&ev=100",
  wxhkbs02:
    "https://open.ys7.com/v3/openlive/AZ1734992_2_1.m3u8?expire=1740729088&id=685152512130424832&t=1e2dbfaf730b839a5c733ae4a73abb2002740132e4e3e8ee49c0608af44d4991&ev=100",
  wxhkbs03:
    "https://open.ys7.com/v3/openlive/AZ1734992_3_1.m3u8?expire=1740729351&id=685153616853569536&t=0171fa0e602ff5a4b983daf5e8da1603f00936846623240b1e29a9315022592f&ev=100",
  wxhkbs04:
    "https://open.ys7.com/v3/openlive/AZ1734992_4_1.m3u8?expire=1740729369&id=685153689664487424&t=11d5426259eea42d6e53722135df68a519781059fc75ca7ecb83145729fa3f51&ev=100",
  yhcklkbs01:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03812PAZ17212/8/1/20240314T055602/7448e5fc1bbd4aab9fb177253d0683b6.m3u8?proto=https",
  yhcklkbs02:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03812PAZ17212/2/1/20240314T055534/0f7bfd75fe483d836db3ee8fe824de2c.m3u8?proto=https",
  yhcklkbs03:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03812PAZ17212/3/1/20240314T055451/64e8333581e85cae30682a1668292bce.m3u8?proto=https",
  yhcklkbs21:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03812PAZ17212/9/1/20240314T055622/a4e6dfaff8af8087a66407d368ba3935.m3u8?proto=https",
  yhcklkbs22:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03812PAZ17212/10/1/20240314T055643/d7450719ce33926ded25dd968ab43c1f.m3u8?proto=https",
  yhcklkbs23:
    "https://cmgw-vpc.lechange.com:8890/LCO/9E03812PAZ17212/1/1/20240314T055238/51006f4f81f562432189f34d59fbacd1.m3u8?proto=https",
  smyskbs01:
    "https://cmgw-vpc.lechange.com:8890/LCO/9M0D899PAZ3668D/0/1/20240329T022434/67b02b6b0a37756f92378a7069e14465.m3u8?proto=https",
  smyskbs02:
    "https://cmgw-vpc.lechange.com:8890/LCO/9M0D899PAZ3668D/1/1/20240329T022541/f4f5f9f0f601fcacb6987186fb8802b6.m3u8?proto=https",
  smyskbs03:
    "https://cmgw-vpc.lechange.com:8890/LCO/9M0D899PAZ3668D/2/1/20240329T022558/10de00d44234531aaa0a2a2da18012f2.m3u8?proto=https",
  smkbs01:
    "https://cmgw-vpc.lechange.com:8890/LCO/9M0D899PAZ3668D/0/1/20240329T022434/67b02b6b0a37756f92378a7069e14465.m3u8?proto=https",
  smkbs02:
    "https://cmgw-vpc.lechange.com:8890/LCO/9M0D899PAZ3668D/1/1/20240329T022541/f4f5f9f0f601fcacb6987186fb8802b6.m3u8?proto=https",
  smkbs03:
    "https://cmgw-vpc.lechange.com:8890/LCO/9M0D899PAZ3668D/2/1/20240329T022558/10de00d44234531aaa0a2a2da18012f2.m3u8?proto=https",
  yhkbs01:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L0B0DBPAZ9DE46/0/0/20240510T091740/1a4b46d9b210371f12f8a92e59792ab7.m3u8?proto=https",
  zjhy001:
    "https://open.ys7.com/v3/openlive/FE1677441_1_2.m3u8?expire=1747275670&id=712610868421619712&t=2d6dc946eee128683f2a9a166bff74d4ee9464ac8d64b20f3462080dba7ee99e&ev=100",
  zjhy002:
    " https://open.ys7.com/v3/openlive/FE1677441_2_2.m3u8?expire=1747288734&id=712665663588130816&t=d2bea00cd4ab418ad4630af1cb169e8dc3baac08ff9039230665b9b83d77f769&ev=100",
  zjhy003:
    "https://open.ys7.com/v3/openlive/FE1677441_3_2.m3u8?expire=1747288752&id=712665738787172352&t=ee96587f3bb0d1030e2261fe2c1079805cb309b7e59a7486e5cc385f971f2ec7&ev=100",
  lxzc001:
    "https://open.ys7.com/v3/openlive/AY1461210_7_2.m3u8?expire=1734945242&id=660893304908427264&t=be4a141c3b493f5a8a26d7902685f62e1807c73ff1771bc81a855cb11d9f7614&ev=100",
  lxzc002:
    "https://open.ys7.com/v3/openlive/AY1461210_12_2.m3u8?expire=1734945273&id=660893433238040576&t=a2c827533048dc07c9664958f4d82790538a769bdf150ec899dcebb1fe9337bc&ev=100",
  lxzc003:
    "https://open.ys7.com/v3/openlive/AY1461210_13_2.m3u8?expire=1734945286&id=660893489277440000&t=fe56cc362bf067d9f280ea36ee2472df81fbfc717c501be4d6acb809b614644b&ev=100",
  lxzc004:
    "https://open.ys7.com/v3/openlive/AY1461210_15_2.m3u8?expire=1734945303&id=660893559285264384&t=78dcee1122294e87604c4056bc1a2e19c706bff0fa57535ef08792426e2cf406&ev=100",
  ahkbs001:
    "https://cmgw-vpc.lechange.com:8890/LCO/7M0193DPAG24401/0/0/20240723T024026/de50037fe21ab23dc822bb7369de89d7.m3u8?proto=https",
  ahkbs002:
    "https://open.ys7.com/v3/openlive/D99958527_1_2.m3u8?expire=1752819329&id=735862658325340160&t=2c19c6e2a7b7cd89f2ad0814033e5b1f5a6f652c93099f76fc7f84e0e8a24de8&ev=100",
  ahkbs003:
    "https://cmgw-vpc.lechange.com:8890/LCO/7M0193DPAG429F4/0/0/20240723T024301/214c95eb8cd9965e3acb5c5370391cf7.m3u8?proto=https",
  ahkbs004:
    "https://open.ys7.com/v3/openlive/D99958571_1_2.m3u8?expire=1752823192&id=735878862419800064&t=83e98fafe73b2afe4aaf6290b3c4413059f333fff81beb54da13b0b4462e03fb&ev=100",
  lykbs001:
    "https://open.ys7.com/v3/openlive/AE1228081_1_1.m3u8?expire=1754206570&id=741681168037982208&t=a3d8e555e09e17911a4300cc6563f1a0a1a00961d1232d936fd277eb8982bdc3&ev=100",
  lykbs002:
    "https://open.ys7.com/v3/openlive/AE1228081_2_1.m3u8?expire=1754206851&id=741682347467874304&t=cc1c01a6da7a1f0c0f6f97f26db4313a3863165efb00ea550da49ef75c1ceaef&ev=100",
  lykbs003:
    "https://open.ys7.com/v3/openlive/AE1228081_3_1.m3u8?expire=1754206861&id=741682390845362176&t=60c513ae820cf9f90eebff20ac2e24422ff9fa2401a06fe3c00e812e99bed9af&ev=100",
  lykbs004:
    "https://open.ys7.com/v3/openlive/AE1228081_4_1.m3u8?expire=1754206879&id=741682466635026432&t=976397a0b884657d18dd449aa7b40b0751505944a06f0284a36bd1b1511d9a01&ev=100",
  cy001:
    "https://open.ys7.com/v3/openlive/AX3542526_2_2.m3u8?expire=1804147542&id=951148787902976000&t=08ca8c91874afe5285b8688db873ebaf7246f61058afbc686aace55b9d56d7cd&ev=101",
  cy002:
    "https://open.ys7.com/v3/openlive/AX3542526_3_1.m3u8?expire=1804147569&id=951148903116795904&t=e24d020a59ed4ecb9ee74fb58552979ea6adc95c278002d1547fce13f8daf515&ev=101",
  cy003:
    "https://open.ys7.com/v3/openlive/AX3542526_1_1.m3u8?expire=1804300261&id=951789339426164736&t=6025345a6349a2d3cfa4ea2e1bb69b422f2dadaec7fc58d30685394c955a83cf&ev=101",
  cy004:
    "https://open.ys7.com/v3/openlive/AX3542526_4_1.m3u8?expire=1804300298&id=951789494074830848&t=a3f6ec2bbc532f6f7717cbe2950ffbccaddcbe290dc36bdac8dc7ed796463e41&ev=101",
  // 黄岩开标室1：
  // 场地编码：zbzbkbshy1.html
  hy1_tzzbs2:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/11/0/20240117T010945/9379db705124b7638bfbfd0f0efe47f6.m3u8?proto=https",
  hy1_tzzbs1:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/1/0/20240117T004804/2fbaf7ec346cef4d02a3ebceebae7d1b.m3u8?proto=https",
  hy1_tzzbs3:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/13/0/20240117T010903/0550828ae1d68236b5567b489c7d576a.m3u8?proto=https",
  hy1_tzzbs4:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/20/0/20240117T004906/c8bac7eb18bfaca6bfa1cb4d6004ee6f.m3u8?proto=https",
  // 黄岩开标室2：
  // 场地编码：zbzbkbshy2.html
  hy2_tzzbs1:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/3/1/20240117T004822/cb6ac25501152c6f33586cb9ccac1ea3.m3u8?proto=https",
  hy2_tzzbs3:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/5/1/20240117T011102/81b25f5621f3b4d1b1aade2c68a3c6ed.m3u8?proto=https",
  hy2_tzzbs2:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/4/1/20240117T011114/fb8c0a8f5455559f8d0abb439b6899e4.m3u8?proto=https",
  hy2_tzzbs4:
    "https://cmgw-vpc.lechange.com:8890/LCO/9L1366FPAZ2D8C4/7/1/20240117T011036/f7f640400fda784dd53c1e2cbbe3aa00.m3u8?proto=https",
};
export default {
  name: "myVideo",
  components: {
    sxt,
  },
  props: {
    bdId: {
      type: String,
    },
  },
  computed: {
    btnsSpan() {
      let s = 24;
      if (this.btns.length) {
        switch (this.btns.length) {
          case 1:
            s = 24;
            break;
          case 2:
            s = 12;
            break;
          case 3:
            s = 8;
            break;
          case 4:
            s = 6;
            break;
        }
      }
      return s;
    },
  },
  data() {
    return {
      btns: [],
      activeBtn: "999",
      activeVideo: 2,
      cdbm: "",
      player: null,
      kbxmZt: sessionStorage.getItem("kbxmZt")
        ? sessionStorage.getItem("kbxmZt")
        : "",
    };
  },
  methods: {
    send(data) {
      this.$emit("send", data);
    },
    changeVideo(id) {
      console.log(id, "222");
      this.activeBtn = id;
      if (id != "999") {
        this.activeVideo = 1;
        this.player.src([
          {
            type: "application/x-mpegURL",
            src: playSrc[id] || "", //
          },
        ]);
        // if(id==12){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/1M04FFFPAMT9203/8/1/20200713T095422/dev_1M04FFFPAMT9203_20200713T095422.m3u8?proto=https" //
        //     }
        //     ]);
        // } else if(id==11){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/1M04FFFPAMT9203/11/0/20201120T060911/1f6a2015679386072e12b53142decbf3.m3u8?proto=https" //
        //     }])
        // } else if(id == 4){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/3/1/20210705T115920/56f99293f74b65f745b2b05ba7c0873f.m3u8?proto=https" //
        //     }])
        // } else if (id == 8){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/7/0/20210705T154444/dd5dbb7c9dc6ab4de34309cca76d0ccd.m3u8?proto=https" //
        //     }])
        // } else if (id == 10){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/9/1/20210705T154552/b4e5ff9984929eddf310e1f5a285d74e.m3u8?proto=https" //
        //     }])
        // } else if (id == 1){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/1/1/20220425T111817/b84a46f754bf0d3e37b5cb026b3de29d.m3u8?proto=https" //
        //     }])
        // } else if (id == 16){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/16/1/20220425T111710/17bb918afc3a6a9694697838f72d30f6.m3u8?proto=https" //
        //     }])
        // } else if (id == 17){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/17/1/20220425T111604/ba3d1d63b7372b333065e3ddb404bca7.m3u8?proto=https" //
        //     }])
        // } else if (id == 998){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7L0D23CPAZA541F/0/0/20230129T013746/bb203e78ec79066e2e6af92f52f3106c.m3u8?proto=https" //
        //     }])
        // } else if (id == 997){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7L0D23CPAZA541F/1/0/20230129T014354/8e55a6f7dd2955e94af306b5279c1853.m3u8?proto=https" //
        //     }])
        // } else if (id == 'tzzbs01'){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/4/1/20210705T115244/d8b5ffb83a93526f7ea5de5cdd8154a6.m3u8?proto=https" //
        //     }])
        // } else if(id == 'tzzbs02'){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/2/1/20220425T113015/4618ed83e0d384362a2dad4b7d8fea1b.m3u8?proto=https" //
        //     }])
        // } else if(id == 'tzzbs03'){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/13/1/20220425T113411/15de53b5242bd10ae411c29be4569d0a.m3u8?proto=https" //
        //     }])
        // } else if(id == 'tzzbs04'){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/7/1/20210705T154444/dd5dbb7c9dc6ab4de34309cca76d0ccd.m3u8?proto=https" //
        //     }])
        // } else if(id == 'tzzbs05'){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/11/1/20220425T111405/d8931179fc0282ee69608712de452118.m3u8?proto=https" //
        //     }])
        // } else if(id == 'tzzbs06'){
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/7C12108PAZ462D7/15/1/20220425T111811/420fca6f9641359b60999e87316e0467.m3u8?proto=https" //
        //     }])
        // }else  {
        //     this.player.src([
        //     {
        //         type: "application/x-mpegURL",
        //         src: "https://cmgw-vpc.lechange.com:8890/LCO/1M04FFFPAMT9203/12/1/20200713T095452/dev_1M04FFFPAMT9203_20200713T095452.m3u8?proto=https" //
        //     }
        // ]);
        // }
      } else {
        this.activeVideo = 2;
      }
    },
    //获取摄像头参数
    getSxt() {
      this.btns = [];
      this.$api
        .getSxtAndLive(this.bdId)
        .then((res) => {
          if (res.data.success) {
            const { sxtInfo } = res.data.data;
            if (sxtInfo.sxtdz) {
              let sxtdz = sxtInfo.sxtdz.split(",");
              this.btns.push({ text: "主持人桌面", id: "999", url: sxtdz[0] });
            }
            sxtInfo.sxtbh.forEach((item, index) => {
              let i = index + 1;
              this.btns.push({ text: "摄像头" + i, id: item });
            });
          }
        })
        .catch(() => {});
    },
    getVideo() {
      this.player = videojs(
        "video",
        {
          bigPlayButton: false,
          textTrackDisplay: false,
          posterImage: true,
          errorDisplay: false,
          controlBar: true,
        }
        // function() {
        //     this.play();
        // }
      );
    },
  },
  mounted() {
    this.getSxt();
    this.$nextTick(() => {
      this.getVideo();
    });
  },
  destroyed() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
<style lang="less">
.video-dimensions {
  overflow: hidden;
  width: 458px;
  height: 270px;
  video {
    width: 100%;
    height: 100%;
  }
}
.video {
  width: 100%;
  height: 270px;
  background: #333;
  position: relative;
  #f_ocx {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    background: #333;
  }
  #f_ocx.active {
    visibility: initial;
  }
  #f_ocx2 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #333;
    //visibility: hidden;
  }
  #f_ocx2.active {
    visibility: initial;
  }
}
.videoBtns {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  button {
    height: 45px;
    line-height: 45px;
    background: #404040;
    color: #fff;
    font-size: 16px;
    width: 100%;
  }
  button.active {
    background: @base-color;
    font-weight: bold;
  }
}
</style>
